// auth services for DQ-Insiders Portal
import crypto from "crypto";
import {removeSaltAtPos, save_e2ee_keys, use_e2ee} from "../utils/utils";
import {invokeApi} from "../bl_libs/invokeApi";
import {LOCAL_STORAGE_KEYS} from "../utils/constants";
import {ECC_cipher_helper} from "../utils/ecc_cipher_util";

const NodeRSA = require('node-rsa');

const getRSAPubKey = async () => {
    let requestObj = {
        path: '/my_dq/auth/passencrypt/pubkey',
        method: 'GET'
    };
    const resp = await invokeApi(requestObj, use_e2ee());
    if (resp.data.publicKey) return resp.data.publicKey;
    return false
}

export const registerUser = async (formData) => {
    let {
        email,
        remember_me,
        ...restOfData
    } = formData;

    let requestObj = {
        path: '/dq_insider/auth/dqin/register',
        method: 'POST'
    };

    let encapsulation = false;
    let xc_dq_encode = false;
    // let _password = password;
    // const publicKeyString = await getRSAPubKey();
    // if (publicKeyString) {
    //     try {
    //         const publicKey = new NodeRSA(publicKeyString);
    //         const nonce = crypto.randomBytes(16).toString('hex');
    //         const timestamp = new Date().toISOString();
    //         const crypto_str = `${nonce}-${timestamp}`;
    //         const password_obj = JSON.stringify({ _password, crypto_str });
    //
    //         password = publicKey.encrypt(password_obj, 'base64');
    //         encapsulation = true;
    //         if (use_e2ee()) xc_dq_encode = true;
    //     } catch (e) {
    //         // will continue sending the plain password text
    //     }
    // }

    requestObj['postData'] = {
        email,
        encapsulation,
        xc_dq_encode,
        ...restOfData
    };

    const result = await invokeApi(requestObj);
    if (xc_dq_encode && result.data && result.data.encoded_inf) {
        // recover the decoded data
        result.data = JSON.parse(atob(removeSaltAtPos(result.data.encoded_inf)));
    }
    if (result.data && result.data.e2ee_pub_key) save_e2ee_keys(result);

    return result;
}


export const loginUser = async (email, _password, remember_me) => {
    let requestObj = {
        path: '/dq_insider/auth/dqin/login',
        method: 'POST'
    };

    let encapsulation = false;
    let xc_dq_encode = false;
    let password = _password;
    const publicKeyString = await getRSAPubKey();
    if (publicKeyString) {
        try {
            const publicKey = new NodeRSA(publicKeyString);
            const nonce = crypto.randomBytes(16).toString('hex');
            const timestamp = new Date().toISOString();
            const crypto_str = `${nonce}-${timestamp}`;
            const password_obj = JSON.stringify({ _password, crypto_str });

            password = publicKey.encrypt(password_obj, 'base64');
            encapsulation = true;
            if (use_e2ee()) xc_dq_encode = true;
        } catch (e) {
            // will continue sending the plain password text
        }
    }

    const postData = {
        email,
        password,
        encapsulation,
        xc_dq_encode,
        remember_me
    };
    requestObj['postData'] = postData;

    const result = await invokeApi(requestObj);
    if (xc_dq_encode && result.data && result.data.encoded_inf) {
        // recover the decoded data
        result.data = JSON.parse(atob(removeSaltAtPos(result.data.encoded_inf)));
    }
    if (result.data && result.data.e2ee_pub_key) save_e2ee_keys(result);

    return result;
}

export const logoutUser = () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/dq_insider/auth/dqin/logout',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        all_devices: true
    };

    return invokeApi(requestObj);
};

export const initResetPassword = (email) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/dq_insider/auth/dqin/init/reset/password',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        email
    };

    return invokeApi(requestObj, use_e2ee());
}

export const resendEmailConfirmation = () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/dq_insider/auth/dqin/email/resend/confirm_token',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };

    return invokeApi(requestObj);
};

export const confirmEmail = (confirmation_token) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/dq_insider/auth/dqin/email/confirm',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        confirmation_token
    };

    return invokeApi(requestObj, use_e2ee());
}

export const changePassword = async (old_password, new_password) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/auth/dqin/password/change',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    requestObj['postData'] = {
        old_password,
        new_password
    };

    return invokeApi(requestObj, use_e2ee());
};


export const resetPassword = async (reset_code, _password) => {
    let requestObj = {
        path: '/dq_insider/auth/dqin/password/reset',
        method: 'POST',
    };

    let encapsulation = false;
    let password = _password;
    const publicKeyString = await getRSAPubKey();
    if (publicKeyString) {
        try {
            const publicKey = new NodeRSA(publicKeyString);
            const nonce = crypto.randomBytes(16).toString('hex');
            const timestamp = new Date().toISOString();
            const crypto_str = `${nonce}-${timestamp}`;
            const password_obj = JSON.stringify({ _password, crypto_str });

            password = publicKey.encrypt(password_obj, 'base64');
            encapsulation = true;
        } catch (e) {
            // will continue sending the plain password text
        }
    }

    requestObj['postData'] = {
        reset_code,
        encapsulation,
        password
    };

    return invokeApi(requestObj);
}

export const userExists = async (email) => {
    let requestObj = {
        path: '/dq_insider/auth/dqin/user_exists',
        method: 'POST'
    }
    requestObj['postData'] = {
        email
    };
    return invokeApi(requestObj, use_e2ee());
}

export const uploadEncryptedMedia = async (file, progressCb) => {

    let requestObj = {
        path: '/dq_insider/encrypted/content/upload',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        onUploadProgress: progressCb,
    };

    const publicKeyString = 'eyJrZXlfb3BzIjpbXSwiZXh0Ijp0cnVlLCJrdHkiOiJFQyIsIngiOiJOQTRyVEZ2MXZsUmdpUGNBbVZiYzNtTXl3MEktQVM2VEpJN0VtRklLN1RVIiwieSI6IjlNTVpXSjRCbWdDNTNiX3B2LVMzRWY3Q3NodFo5eVVmZEJXdUN0Wk9qVzAiLCJjcnYiOiJQLTI1NiJ9';
    let secure_data = null;
    let encapsulation = false;

    if (publicKeyString) {
        try {
            const publicKey = atob(publicKeyString);
            const arrayBuffer = await file.arrayBuffer();
            const buffer = Buffer.from(arrayBuffer);

            const base64Data = buffer.toString('base64');
            secure_data = await ECC_cipher_helper.encryptData(base64Data, JSON.parse(publicKey));

            encapsulation = true;
        } catch (e) {
            console.error("RSA encryption failed", e);
        }
    }

    requestObj["postData"] = {
        encapsulation,
        media: secure_data,
        originalFileName: file.name,
        mimeType: file.type,
        extension: file.name.split('.').pop()
    };;

    return invokeApi(requestObj, use_e2ee());
};

export const refreshToken = () => {
    const auth_token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const refresh_token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.refresh_token));
    let requestObj = {
        path   : '/dq_insider/auth/dqin/refresh/token',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${auth_token}`,
            'Refresh-Token': refresh_token
        }
    };
    requestObj['postData'] = {
        auth_token,
        refresh_token
    };

    return invokeApi(requestObj, use_e2ee());
};